import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from 'app/classes/user';
import { AuthService } from 'app/services/auth.service';
import { PlanMetadata } from 'fitforce-document-sync';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'plan-document-list-item',
  templateUrl: './plan-document-list-item.component.html',
  styleUrls: ['./plan-document-list-item.component.scss'],
})
export class PlanDocumentListItemComponent {
  @Input() plan: PlanMetadata;
  @Input() isOnline: boolean;
  @Output() clicked: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();
  @Output() viewed: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();
  @Output() downloaded: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();
  @Output() published: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();
  @Output() shared: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();
  @Output() copied: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();
  @Output() deleted: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();
  @Output() edited: EventEmitter<PlanMetadata> = new EventEmitter<PlanMetadata>();

  get creatorName(): string {
    if (this.plan.createdByUser) {
      return `${this.plan.createdByUser.firstName} ${this.plan.createdByUser.lastName}`;
    }
  }

  get isPublished(): boolean {
    return this.plan.publishedToGroups && this.plan.publishedToGroups.length > 0;
  }

  constructor(private authService: AuthService) {}

  isOwner(): Observable<boolean> {
    return this.authService.currentUserObs.pipe(
      map((currentUser: User) => {
        return currentUser && this.plan.userUUID === currentUser.uuid;
      }),
    );
  }
}
